// extracted by mini-css-extract-plugin
module.exports = {"areas":"Products_areas__2ADjU"};